import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { withAuth } from '../AuthContext'
import styled from 'styled-components'
import { CustomSelect } from './CustomClasses'

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;

  @media screen and (max-width: 768px) {
    gap: 6px;
  }
`

const CustomSelectDD = styled(CustomSelect)`
  flex-basis: 32%;
`

const CustomSelectMM = styled(CustomSelect)`
  flex-basis: 32%;
`

const CustomSelectYYYY = styled(CustomSelect)`
  flex-basis: 36%;
`

const DateDropDown = ({
  updateDobDay,
  updateDobMonth,
  updateDobYear,
  dobDayError,
  dobMonthError,
  dobYearError,
  existingDay,
  existingMonth,
  existingYear,
}) => {
  const [dobDays, setDobDays] = useState([])
  const [dobMonths, setDobMonths] = useState([])
  const [dobYears, setDobYears] = useState([])

  useEffect(() => {
    setDobDays(generateDropdownArr(1, 31))
    setDobMonths(generateDropdownArr(1, 12))

    const thisYear = new Date().getFullYear()
    const firstDobYear = thisYear - 49
    const lastDobYear = firstDobYear - 80

    setDobYears(generateDropdownArr(firstDobYear, lastDobYear))

    existingDay && updateDobDay(existingDay)
    existingMonth && updateDobMonth(existingMonth)
    existingYear && updateDobYear(existingYear)
  }, [])

  const generateDropdownArr = (startVal, endVal) => {
    var valArr = []
    var incrementVal = startVal

    if (startVal <= endVal) {
      while (incrementVal <= endVal) {
        const currentInput = {
          value: incrementVal,
          label: ('0' + incrementVal).slice(-2),
        }
        valArr.push(currentInput)
        incrementVal += 1
      }
    } else {
      while (incrementVal >= endVal) {
        const currentInput = {
          value: incrementVal,
          label: incrementVal,
        }
        valArr.push(currentInput)
        incrementVal -= 1
      }
    }

    return valArr
  }

  const updateDay = (e) => {
    updateDobDay(e.value)
  }

  const updateMonth = (e) => {
    updateDobMonth(e.value)
  }

  const updateYear = (e) => {
    updateDobYear(e.value)
  }

  /*
  if (!existingDay || !existingMonth || !existingYear) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border onboarding-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }
    */
  return (
    <FlexRow>
      {' '}
      <CustomSelectDD
        size="14px"
        width="-webkit-fill-available"
        placeholder="DD"
        defaultValue={{
          value: existingDay ? existingDay : 'DD',
          label: existingDay ? existingDay : 'DD',
        }}
        className={dobDayError && 'error-border'}
        isDisabled={false}
        isLoading={false}
        isClearable={false}
        isRtl={false}
        isSearchable={true}
        name="dobday"
        options={dobDays}
        onChange={(e) => updateDay(e)}
      />{' '}
      <CustomSelectMM
        size="14px"
        width="-webkit-fill-available"
        placeholder="MM"
        defaultValue={{
          value: existingMonth ? existingMonth : 'MM',
          label: existingMonth ? existingMonth : 'MM',
        }}
        className={dobMonthError && 'error-border'}
        isDisabled={false}
        isLoading={false}
        isClearable={false}
        isRtl={false}
        isSearchable={true}
        name="dobmonth"
        options={dobMonths}
        onChange={(e) => updateMonth(e)}
      />{' '}
      <CustomSelectYYYY
        size="14px"
        width="-webkit-fill-available"
        placeholder="YYYY"
        defaultValue={{
          value: existingYear ? existingYear : 'YYYY',
          label: existingYear ? existingYear : 'YYYY',
        }}
        className={dobYearError && 'error-border'}
        isDisabled={false}
        isLoading={false}
        isClearable={false}
        isRtl={false}
        isSearchable={true}
        name="dobyear"
        options={dobYears}
        onChange={(e) => updateYear(e)}
      />
    </FlexRow>
  )
}

export default withRouter(withAuth(DateDropDown))
